import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Media, Button, ButtonGroup } from "reactstrap";
import { Link } from "react-router-dom";
import SpecificationDataCubes from "./SpecificationDataCubes";
import SpecificationDataTable from "./SpecificationDataTable";
import { joinCss } from "../helpers/utils";
import { getAllSpecificatios } from "../actions/filesActions";

import classes from "./specificationData.module.scss";

import backArrow from "../images/backArrow.png";
import editionBlue from "../images/editionBlue.png";
import fixBlue from "../images/fixBlue.png";
import cubes from "../images/cubes.png";
import cubesSelected from "../images/cubesSelected.png";
import list from "../images/list.png";
import listSelected from "../images/listSelected.png";

class SpecificationData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      specification: null,
      showTable: false
    };
    this.toggleDisplayMode = this.toggleDisplayMode.bind(this);
  }

  toggleDisplayMode(show) {
    this.setState({ showTable: show });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != null) {
      this.setState({
        specification: nextProps.data.find(x => x.id === this.state.id)
      });
    }
  }

  componentDidMount() {
    this.props.onLoadData();
  }
  render() {
    if (this.state.specification) {
      return (
        <Container className="px-0">
          <Row>
            <Col sm="4">
              <Container className={joinCss(classes.rightContainer, "px-0")}>
                <Row>
                  <Col sm="2">
                    <Link
                      className={joinCss(classes.linkText, "mr-4")}
                      to={{
                        pathname: "/AllSpecifications/"
                      }}
                    >
                      <Media src={backArrow} alt="חזרה לכל הפרקים" />
                    </Link>
                  </Col>
                  <Col sm="10">
                    <span className={classes.idText}>
                      {this.state.specification.idForName}
                    </span>
                    <br />
                    <span className={classes.descriptionText}>
                      {this.state.specification.description}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col md="2" />
                  <Col className="pl-0">
                    <Media object src={editionBlue} alt="מהדורה" />
                    <span className={joinCss(classes.numberText, "pl-2")}>
                      {this.state.specification.numberOfEditions}
                    </span>
                    <Media object src={fixBlue} alt="דפי תיקון" />
                    <span className={classes.numberText}>
                      {this.state.specification.numberOfFixes}
                    </span>
                  </Col>
                </Row>
                <Row className="py-5">
                  <Col md="2" />
                  <Col>
                    <span>עודכן לאחרונה:</span>
                    <span>{this.state.specification.publishAt}</span>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col sm="8">
              <Row>
                <Col sm="12">
                  <ButtonGroup className="float-left pt-2" size="sm">
                    <Button
                      color="link"
                      onClick={() => this.toggleDisplayMode(true)}
                      active={this.state.showTable === true}
                    >
                      <Media
                        className={classes.displayOptionImage}
                        src={
                          this.state.showTable === true ? listSelected : list
                        }
                        alt="תצוגת טבלה"
                      />
                    </Button>
                    <Button
                      color="link"
                      onClick={() => this.toggleDisplayMode(false)}
                      active={this.state.showTable === false}
                    >
                      <Media
                        className={classes.displayOptionImage}
                        src={
                          this.state.showTable === false ? cubesSelected : cubes
                        }
                        alt="תצוגת רשימה"
                      />
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              {this.state.showTable ? (
                <SpecificationDataTable
                  editions={this.state.specification.editions}
                />
              ) : (
                <SpecificationDataCubes
                  editions={this.state.specification.editions}
                />
              )}
            </Col>
          </Row>
        </Container>
      );
    } else {
      return <div>טוען מידע נא להמתין</div>;
    }
  }
}

const mapStateToProps = state => {
  return {
    data: state.files.allSpecifications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadData: () => dispatch(getAllSpecificatios())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecificationData);
